<div *ngIf="currentBalance" class="flex flex-col">
	<div class="flex flex-row">
		<span class="flex ml-2 align-middle items-center"> Teranet balance </span>
	</div>
	<span class="flex justify-end font-bold text-xl">
		{{ currentBalance | centsToDollars }}
	</span>
</div>
